import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  return Yup.object({
    userGroupMasterId: Yup.number().required(requiredMessage),
    orgCode: Yup.string(),
    userGroupCode: Yup.string(),
    userGroupName: Yup.string(),
    companyType: Yup.string(),
  })
}

export default makeValidationSchema
